module.exports = __webpack_public_path__ + "img/ve_white.49b6a80a.svg";